import { ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER, N } from '@angular/cdk/keycodes';
import { MatSelectChange } from '@angular/material/select';
import { AuthService } from 'src/app/core/services/auth.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar'; // at the top
import { AddCategoryDialogComponent } from '../add-category-dialog/add-category-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/shared/confirmation-dialog/confirmation-dialog.component';


function noSpacesValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value == null) return null;
  const value = control.value as string;
  if (value.trim().length === 0) {
    return { whitespace: true }; // only spaces
  }
  return null;
}


export function expirationDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    console.log('Expiration validator running:', control.value);
    if (!control.value) return null;

    const selectedDate = new Date(control.value);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // remove time

    if (selectedDate <= today) {
      return { expirationTooSoon: true };
    }
    return null;
  };
}

export function duplicateNameValidator(
  existingDocuments: any[] = [],
  selectedCategories?: string[] | null,
  originalName?: string,
  mode: 'global' | 'category' = 'category'  // Changed default to 'category'
): ValidatorFn {
  const normalizedOriginal = (originalName || '').trim().toLowerCase();

  const docs = Array.isArray(existingDocuments) ? existingDocuments : [];

  // Build the set of existing names according to the chosen mode
  const namesToCheck: string[] = docs
    .filter((doc: any) => {
      const hasName = typeof doc?.name === 'string' && doc.name.trim().length > 0;
      if (!hasName) return false;

      if (mode === 'global') {
        return true; // check across all personal documents
      }

      // category-scoped (exact match for selected categories)
      const docCats: string[] = Array.isArray(doc?.category) ? doc.category : (doc?.category ? [doc.category] : []);
      const selCats: string[] = Array.isArray(selectedCategories) ? selectedCategories : [];
      
      // Check if there's any overlap between document categories and selected categories
      return docCats.some((c: string) => selCats.includes(c));
    })
    .map((doc: any) => (doc?.name || '').trim().toLowerCase());

  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value = (control.value || '').trim().toLowerCase();
    if (!value) return null;
    if (normalizedOriginal && value === normalizedOriginal) return null;
    if (namesToCheck.includes(value)) {
      return { duplicateName: true };
    }
    return null;
  };
}


interface DocumentCategory {
  id: string;
  title: string; // Updated to include title
  icon: string;
  documentTypes?: any; // Added documentTypes
}

@Component({
    selector: 'app-add-document-dialog',
    templateUrl: './add-document-dialog.component.html',
    styleUrls: ['./add-document-dialog.component.css'],
    standalone: false
})
export class AddDocumentDialogComponent {
documentForm: FormGroup;
  fileForms: FormArray = this.fb.array([]);
  selectedFiles: File[] = [];
  uploadProgress: number = 0;
  isUploading: boolean = false;
  isIdentitySelected: boolean = false;
  otherSelected: boolean = false;
  currentStep: number = 1;
  tags: string[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  dialogMode: 'add' | 'edit';
  chkexp = false;
  doclist:any;
  country:any
  error_msg:any[] =[];
  succes_msg:any[]=[];
  counter=0;
  maxDate = new Date();
  minDate = new Date(this.maxDate.setDate(this.maxDate.getDate()+1));
  allowed_exe =  ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/pdf","image/jpg","image/jpeg","image/gif","image/bmp","image/png","text/plain","application/rtf", "application/vnd.ms-excel","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
  allowed_exe_status = false;
  isDragOver = false;
  allPersonalDocs: any[] = [];
  identityAccept = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
  generalAccept =
  '.pdf,.doc,.docx,.jpg,.jpeg,.png,' +
  '.ppt,.pptx,' +
  '.xls,.xlsx,' +
  '.rtf,.csv';
  identityId:any;
  submitted = false;
  docId: string = 'Document ID';
  docTypes: { [key: string]: string | number } = {
  driver_license: "Driver's License Number",
  passport: 'Passport Number',
  aadhar: 'AADHAR Number',
  // tfn: 'Tax File Number',
  voterid: 'Voter ID',
  pancard: 'PAN Number',
};

  
  
  uploadProgressList: { progress: number; status: string }[] = [];
  @ViewChild('fileList') fileList?: ElementRef<HTMLElement>;
  COUNTRIES_IDOC_MAP : { [key: string]: { [key: string]: string } }={
  'Argentina': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Document (DNI)','passport': 'Passport'},
  'Australia': {'driver_license': 'Driver\'s Licence','tfn':'Tax File Number (TFN)','passport': 'Passport'},
  'Austria': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (CCR ID)','passport': 'Passport'},
  'Belgium': {'driver_license': 'Driver\'s Licence','nic': 'National Register Number (National ID)','passport': 'Passport'},
  'Bosnia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'Brazil': {'cpf':'Cadastro de Pessoas Físicas (CPF)','driver_license': 'Driver\'s Licence','nic': 'National Identity Card','passport': 'Passport','ssc': 'Social Security Card'},
  'Bulgaria': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Civil Number)','passport': 'Passport'},
  'Canada': {'driver_license': 'Driver\'s Licence','sic':'Social Insurance Card','passport': 'Passport'},
  'Chile': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (RUN / RUT)','passport': 'Passport'},
  'China': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (ID Number)','passport': 'Passport'},
  'Croatia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Identification Number - OIB)','passport': 'Passport'},
  'Czech Republic': {'birth_number':'Birth Number','driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Identification Card Number)','passport': 'Passport'},
  'Denmark': {'cvr_number':'CVR Number','driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Identification - CPR Number)','passport': 'Passport','vat_number':'VAT Registration Number'},
  'Estonia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Identification Code / Number)','passport': 'Passport'},
  'Finland': {'driver_license': 'Driver\'s Licence','hetu':'Personal Identification Number (HETU)','nic': 'National Identity Card','passport': 'Passport'},
  'France': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card / Number','passport': 'Passport'},
  'Herzegovina': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'Iceland': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Kennitala)','passport': 'Passport'},
  'India': {'aadhar': 'AADHAR Card','driver_license': 'Driver\'s Licence','pancard': 'PAN Card','passport': 'Passport','voterid': 'Voter ID'},
  'Indonesia':{'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (National ID)','passport': 'Passport'},
  'Israel': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (National ID)','passport': 'Passport'},
  'Italy': {'driver_license': 'Driver\'s Licence','hic':'Health Insurance Card','nic': 'National Identity Card (Fiscal Code Card)','passport': 'Passport'},
  'Latvia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Code)','passport': 'Passport'},
  'Lithuania': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Code)','passport': 'Passport'},
  'Macedonia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'Malaysia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (National ID)','passport': 'Passport'},
  'Mexico': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (CURP) ','passport': 'Passport','ssc': 'Social Security Card'},
  'Moldova': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Personal Code)','passport': 'Passport'},
  'Montenegro': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'Netherlands': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Service / Personal Number)','passport': 'Passport'},
  'New Zealand': {'driver_license': 'Driver\'s Licence','nhi':'National Health Index Number','passport': 'Passport'},
  'Norway': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Birth Number)','passport': 'Passport'},
  'Poland': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Polish National ID Card)','tin':'Tax Identification Number (NIP)','passport': 'Passport','pesel_number':'PESEL Number','regon':'REGON - Identification for Business'},
  'Portugal': {'driver_license': 'Driver\'s Licence','hun':'Health User Number','ic_number':'Civil Identification Number','passport': 'Passport','ssc': 'Social Security Card /  Number','tin':'Tax Identification Number','voterid': 'Voter ID / Number'},
  'Romania': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card / Personal Numeric Code - CNP','passport': 'Passport'},
  'Serbia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'Singapore': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (National ID)','passport': 'Passport'},
  'Slovakia': {'birth_number':'Birth Number','driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Identification Card Number)','passport': 'Passport'},
  'Slovenia': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Citizen Number)','passport': 'Passport'},
  'South Africa': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card','passport': 'Passport'},
  'South Korea': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (Resident Registration Number)','passport': 'Passport'},
  'Spain': {'driver_license': 'Driver\'s Licence','nic': 'National Identity Card (DNI)','nie': 'NIE','passport': 'Passport'},
  'Sweden': {'driver_license': 'Driver\'s Licence','con': 'Co-Ordination Number','orn':'Organisation Number','passport': 'Passport','nic':'National Identity Card (Personal Identity Number - PIN)'},
  'Switzerland': {'driver_license': 'Driver\'s Licence','passport': 'Passport','ssc': 'Social Security Card'},
  'Turkey': {'driver_license': 'Driver\'s Licence','passport': 'Passport','nic': 'National Identity Card (Turkish Identification Number)'},
  'Ukraine': {'driver_license': 'Driver\'s Licence','passport': 'Passport','nic': 'National Identity Card (Individual Identification Number)'},
  'United Kingdom': {'nino':'National Insurance Number','nhsn':'National Health Service Number','driver_license': 'Driver\'s Licence','passport': 'Passport','ssc': 'Social Security Card','nic':'National Identity Card (Identity Card)'},
  'USA':{'driver_license': 'Driver\'s Licence','passport': 'Passport','ssc': 'Social Security Card'},
  'United Arab Emirates':{'nic': 'National ID','passport': 'Passport'},


  [Symbol.iterator]: function* () {
    let properties = Object.keys(this);
    for (let i of properties) {
        yield [i, this[i]];
    }
}  

  }
 successCount: any = [];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddDocumentDialogComponent>,
    public auth: AuthService, private snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: {
      mode: 'add' | 'edit',
      document?: any,
      categories: DocumentCategory[],
      defaultCategory?: string,
      index_country?: string,
      country?: string,
      existingDocuments?: any[]
    }
  ) {
    this.dialogMode = data.mode;
    this.isIdentitySelected = data?.defaultCategory === 'identity';
    console.log(data)
    this.documentForm = this.createForm();
    
    // Initialize tags for identity documents
    if (this.isIdentitySelected && data.document?.user_tags) {
      this.tags = [...data.document.user_tags];
    }
    
    if (this.dialogMode === 'edit' && data.document) {
      this.tags = [...data.document.user_tags];
      this.documentForm.patchValue(data.document);
      this.currentStep = 2; // Skip file upload step for edit mode
    }
  }

  ngOnInit() {
    // console.log("Data received in AddDocumentDialogComponent:", this.data);
    // console.log(this.documentForm)
  
    if (this.dialogMode === 'edit' && this.isIdentitySelected) {
    // For identity documents in edit mode, disable categories and document type
    this.documentForm.get('categories')?.disable({ emitEvent: false });
    this.documentForm.get('documentType')?.disable({ emitEvent: false });
  } else if ((this.dialogMode === 'add' && this.currentStep === 2) && this.isIdentitySelected) {
    // For identity documents in add mode step 2, only disable document type
    this.documentForm.get('documentType')?.disable({ emitEvent: false });
  }

     // Set validation for edit mode
    if (this.chkexp && this.dialogMode === 'edit' ) {
      const control = this.documentForm.get('expirationDate');
      control?.setValidators([Validators.required, expirationDateValidator()]);
      control?.updateValueAndValidity();
    }


    if (this.dialogMode === 'edit' && this.isIdentitySelected) {
      const currentDocType = this.documentForm.get('documentType')?.value;
      this.chkexp = (currentDocType === 'passport' || currentDocType === 'driver_license');
      this.check_doctype_exp({ value: currentDocType });
    }

    
    // Only set expiration date validation for non-identity documents
    if (!this.isIdentitySelected) {
      this.documentForm.get('expirationDate')?.valueChanges.subscribe((date) => {
        if (date && date < this.minDate) {
          this.documentForm.get('expirationDate')?.setErrors({ expirationTooSoon: true });
        }
      });
    }

    if(this.data.defaultCategory=="identity") {
      this.IdentitySelectedFn();
      
  } else {
      this.isIdentitySelected = false;
      //this.data.categories = this.data.categories.filter(cat => cat.title !== 'Identity');
  }

    // Load global personal documents to align with backend uniqueness (prevents 409)
    if (!this.isIdentitySelected && this.data?.index_country) {
      this.auth.get_personal_docs(this.data.index_country).subscribe({
        next: (res: any) => {
          const docs = res?.data?.documents || [];
          this.allPersonalDocs = Array.isArray(docs) ? docs : [];
          this.applyCategoryNameValidators();
        },
        error: () => {
          // fallback to provided list if fetch fails
          this.allPersonalDocs = this.data.existingDocuments || [];
          this.applyCategoryNameValidators();
        }
      });
    } else {
      // identity or no country → no personal duplicate validation needed here
      this.applyCategoryNameValidators();
    }

    // Show validation messages immediately in edit step for non-identity
    if (this.dialogMode === 'edit' && !this.isIdentitySelected) {
      this.documentForm.get('name')?.markAsTouched();
      this.documentForm.get('description')?.markAsTouched();
      this.documentForm.updateValueAndValidity();
    }

    console.log(">>>>>>>>>>>>>>>>>>>>>>>",this.documentForm.get('documentType')?.value, this.isIdentitySelected && !this.documentForm.get('documentType')?.value)
    if (this.isIdentitySelected && !this.documentForm.get('documentType')?.value) {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>")
    const firstDocTypeKey = Object.keys(this.doclist)[0];
    if (firstDocTypeKey) {
      this.documentForm.get('documentType')?.setValue(firstDocTypeKey);
      this.check_doctype_exp({ value: firstDocTypeKey });
    }
  }

  }

  /**
 * Check if a category should be disabled in the dropdown
 */
isCategoryDisabled(categoryId: string, categoryTitle: string): boolean {
  // In edit mode for identity documents, disable all categories
  if (this.dialogMode === 'edit' && this.isIdentitySelected) {
    return true;
  }
  
  // For non-identity documents (personal categories), disable only Identity category
  if (!this.isIdentitySelected && categoryTitle === 'Identity') {
    return true;
  }
  
  // For identity documents in add mode, disable non-identity categories
  if (this.isIdentitySelected && this.dialogMode === 'add' && categoryTitle !== 'Identity') {
    return true;
  }
  
  return false;
}

/**
 * Check if document type field should be disabled
 */
isDocumentTypeDisabled(): boolean {
  return this.dialogMode === 'edit' && this.isIdentitySelected;
}

  IdentitySelectedFn(){

    this.isIdentitySelected = true;    
      this.identityId = this.data.categories.find(cat => cat.title === 'Identity')?.id; 
      this.documentForm.get('categories')?.setValue([this.identityId]);
       for (let  [k, v]  of Object.entries(this.COUNTRIES_IDOC_MAP)) {
      if(k==this.data.country){
        this.doclist = v
        if (this.data.country === 'India' && String(this.data.index_country || '').toLowerCase() !== 'citizen_primary') {
          delete this.doclist['passport'];
          this.doclist = {
          ...this.doclist,
          pio: 'PIO (Person of Indian Origin)',
          oci: 'OCI (Overseas Citizen of India)',
    };
  }
      }
      
    }
    
  }



// openAddCategoryDialog(): void {
//   const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
//     width: '500px',
//     data: { existingCategories: this.data.categories }
//   });

//   dialogRef.afterClosed().subscribe(result => {
//     if (result) {
//       const payload = {
//         category: result.name,
//         symbol: result.icon
//       };

//       this.auth.add_tags(this.data.index_country, payload).subscribe({
//         next: (res: any) => {
//           if (res.error === false) {
//             // Use the actual ObjectId returned from the API
//             const newCategoryId = res.data?.id || res.data?.category_id || result.name.toLowerCase();
            
//             const newCategory = {
//               id: newCategoryId,
//               title: result.name,
//               count: 0,
//               icon: result.icon,
//               isActive: false
//             };

//             // Add to local list
//             this.data.categories.push(newCategory);

//             // Auto-select in form - Clean up the categories array
//             const categoriesControl = this.documentForm.get('categories');
//             const currentCategories = categoriesControl?.value || [];
            
//             // Filter out null/undefined values and non-string values
//             const cleanCategories = currentCategories.filter((cat: any) => 
//               cat != null && typeof cat === 'string' && cat.trim() !== ''
//             );
            
//             // Add the new category ID (use the ObjectId from API response)
//             const updatedCategories = [...cleanCategories, newCategoryId];
            
//             categoriesControl?.setValue(updatedCategories);
            
//             // Trigger category selection logic to update validators
//             this.onCategorySelect({ value: updatedCategories } as MatSelectChange);

//             this.toastr.success(res.msg);
//           } else {
//             this.toastr.error(res.msg);
//           }
//         },
//         error: (err) => {
//           console.error('API Error:', err);
//           this.toastr.error(err?.error?.msg || 'Something went wrong.');
//         }
//       });
//     }
//   });
// }





  private applyCategoryNameValidators(): void {
    if (this.isIdentitySelected) return;

    const source = (this.allPersonalDocs && this.allPersonalDocs.length)
      ? this.allPersonalDocs
      : (this.data.existingDocuments || []);

    const nameControl = this.documentForm.get('name');
    const selectedCategories = this.documentForm.get('categories')?.value;
    
    nameControl?.setValidators([
      Validators.required,
      Validators.maxLength(30),
      duplicateNameValidator(source, selectedCategories, this.data.document?.name, 'category')
    ]);
    nameControl?.updateValueAndValidity({ emitEvent: false });

    // Also update any existing file forms
    this.fileForms.controls.forEach((grp: any) => {
      const ctrl = grp.get('name');
      if (ctrl) {
        ctrl.setValidators([
          Validators.required,
          Validators.maxLength(30),
          duplicateNameValidator(source, selectedCategories, undefined, 'category')
        ]);
        ctrl.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  private createForm(): FormGroup {
    return this.fb.group({
      id: [this.data.document?.id || ''],
      name: [
        this.data.document?.name || '',
        this.isIdentitySelected
          ? null
          : [
              Validators.required,
              Validators.maxLength(30),noSpacesValidator,
              // will be refreshed in ngOnInit once global list loads with category-scoped validation
              duplicateNameValidator(this.data.existingDocuments || [], this.data.defaultCategory ? [this.data.defaultCategory] : [], this.data.document?.name, 'category')
            ]
      ],
      description: [
        this.data.document?.description || '',
        this.isIdentitySelected ? null : [Validators.required, Validators.maxLength(500),noSpacesValidator]
      ],
      categories: [this.data.document?.categories || [this.data.defaultCategory ], Validators.required],
      documentType: [{
        value: this.data.document?.doctype || '',
        disabled: this.dialogMode === 'edit' && this.isIdentitySelected},
      this.isIdentitySelected ? Validators.required : null
    ],
      documentId: [this.data.document?.docid || ''],
      files: [[], this.dialogMode === 'add' ? Validators.required : null],
      // Remove expiration date for identity documents as per the image
      expirationDate: [this.data.document?.expirationDate || ''],
      tags: [this.data.document?.user_tags || []]
    });
  }


  createFileForm(file: File): FormGroup {
    return this.fb.group({
      id: [this.data.document?.id || ''],
      name: [
        this.data.document?.name || '',
        [
          Validators.required,
          Validators.maxLength(30),
          // will be refreshed in ngOnInit once global list loads with category-scoped validation
          duplicateNameValidator(this.data.existingDocuments || [], this.data.defaultCategory ? [this.data.defaultCategory] : [], undefined, 'category')
        ]
      ],
      description: [
        this.data.document?.description || '',
        [Validators.required, Validators.maxLength(500)]
      ],
      categories: [this.data.document?.categories || [this.data.defaultCategory], Validators.required],
      files: [[], this.dialogMode === 'add' ? Validators.required : null],
      // expirationDate: [this.data.document?.expirationDate || ''],
      expirationDate: [this.data.document?.expirationDate || '', [expirationDateValidator()]],
      tags: [this.data.document?.user_tags || []]
    });
  }
  get fileFormGroupArray(): FormGroup[] {
    return this.fileForms.controls as FormGroup[];
  }
  get fileFormArray(): FormArray {
    return this.fileForms;
  }

onCategorySelect(event: MatSelectChange): void {
    console.log('Category selection changed:', event.value);
    const selectedCategories = event.value as string[];
    this.isIdentitySelected = selectedCategories.includes(this.data.categories.find(cat => cat.title === 'Identity')?.id || '');
    if(this.isIdentitySelected) {
    this.IdentitySelectedFn();

    }

    // Dynamically toggle validators based on Identity selection
    const nameControl = this.documentForm.get('name');
    const descriptionControl = this.documentForm.get('description');
    const documentTypeControl = this.documentForm.get('documentType');
    const documentIdControl = this.documentForm.get('documentId');
    const expirationDateControl = this.documentForm.get('expirationDate');

    if (this.isIdentitySelected) {
      nameControl?.clearValidators();
      descriptionControl?.clearValidators();
      documentTypeControl?.setValidators(Validators.required);
      documentIdControl?.setValidators(Validators.required);
      // Remove expiration date validation for identity documents
      expirationDateControl?.clearValidators();
      const currentDocType = this.documentForm.get('documentType')?.value;
    if (currentDocType === 'driver_license' || currentDocType === 'passport') {
      expirationDateControl?.setValidators(Validators.required);
      this.chkexp = true;
    } else {
      expirationDateControl?.clearValidators();
      this.chkexp = false;
    }
    } else {
      nameControl?.setValidators([
        Validators.required,
        Validators.maxLength(30),
        duplicateNameValidator(this.allPersonalDocs || this.data.existingDocuments || [], selectedCategories, this.data.document?.name, 'category')
      ]);
      descriptionControl?.setValidators([Validators.required, Validators.maxLength(500)]);
      documentTypeControl?.clearValidators();
      documentIdControl?.clearValidators();
      // Add expiration date validation for non-identity documents
      expirationDateControl?.setValidators([expirationDateValidator()]);
      
      // Re-apply category-scoped validation to file forms
      this.fileForms.controls.forEach((form: any) => {
        const ctrl = form.get('name');
        if (ctrl) {
          ctrl.setValidators([
            Validators.required,
            Validators.maxLength(30),
            duplicateNameValidator(this.allPersonalDocs || this.data.existingDocuments || [], selectedCategories, undefined, 'category')
          ]);
          ctrl.updateValueAndValidity({ emitEvent: false });
        }
      });
    }

    nameControl?.updateValueAndValidity();
    descriptionControl?.updateValueAndValidity();
    documentTypeControl?.updateValueAndValidity();
    documentIdControl?.updateValueAndValidity();
    expirationDateControl?.updateValueAndValidity();
  }


// Updated moveToNextStep method with better validation
// Updated moveToNextStep method with better validation
moveToNextStep(): void {

   console.log('Move to next step clicked. Current step:', this.currentStep, 'Dialog mode:', this.dialogMode);
    console.log(this.documentForm)
   if (this.currentStep === 1 && this.dialogMode === 'add') {
    // Step 1 validation - only validate categories, files, and document type for identity
    const categoriesValid = this.documentForm.get('categories')?.valid;
    const hasValidCategories = this.documentForm.get('categories')?.value?.length > 0;
    const hasFiles = this.selectedFiles.length > 0;
    if(this.isIdentitySelected && this.selectedFiles.length>1){
      this.toastr.error('You can upload only one file for Identity documents.');
      return;
    }
    
    // For identity documents, also check document type
    let documentTypeValid = true;
    if (this.isIdentitySelected) {
      documentTypeValid = this.documentForm.get('documentType')?.valid ?? false;
    }
    
    if (categoriesValid && hasValidCategories && hasFiles && documentTypeValid) {
      this.currentStep = 2;
      const fileName = this.selectedFiles[0]?.name;
      if (fileName && !this.isIdentitySelected) {
        this.documentForm.patchValue({ name: fileName, description: fileName });
      }
      
      // DO NOT mark forms as touched here - let validation show only when Save is clicked
      // Remove the following lines that were causing premature validation:
      // this.documentForm.markAllAsTouched();
      // this.documentForm.updateValueAndValidity();
      // this.fileForms.controls.forEach((form: any) => {
      //   form.markAllAsTouched();
      //   form.updateValueAndValidity();
      // });
      
    } else {
      // Show specific error messages for step 1 validation
      if (!hasValidCategories) {
        this.toastr.error('Please select at least one category.');
      } else if (!hasFiles) {
        this.toastr.error('Please select at least one file.');
      } else if (this.isIdentitySelected && !documentTypeValid) {
        this.toastr.error('Please select a document type.');
      }
    }
    return;
  }

  if ((this.currentStep === 2 || this.dialogMode === 'edit')) {
    // NOW mark all forms as touched for step 2 validation (Save button)
    this.submitted = true
    this.documentForm.markAllAsTouched();
    this.documentForm.updateValueAndValidity();
    
    // Mark file forms as touched for validation
    this.fileForms.controls.forEach((form: any) => {
      form.markAllAsTouched();
      form.updateValueAndValidity();
    });

    let isFormValid = false;
    if (this.isIdentitySelected) {
      const documentIdControl = this.documentForm.get('documentId');
      documentIdControl?.addValidators(Validators.required);
      documentIdControl?.updateValueAndValidity();
      const expirationControl = this.documentForm.get('expirationDate');
      if (this.chkexp) {
        expirationControl?.addValidators([Validators.required, expirationDateValidator()]);
        expirationControl?.updateValueAndValidity();
      }
      const categoriesValid = this.documentForm.get('categories')?.valid ?? false;
      const documentTypeValid = this.documentForm.get('documentType')?.valid ?? false;
      const documentIdValid = this.documentForm.get('documentId')?.valid ?? false;
      const filesValid = this.documentForm.get('files')?.valid ?? false;
      let expirationValid = true;
      if (this.chkexp) {
        expirationValid = this.documentForm.get('expirationDate')?.valid ?? false;
      }
      isFormValid = categoriesValid && documentTypeValid && documentIdValid && expirationValid && (filesValid || this.dialogMode === 'edit');
    } else {
      isFormValid = this.fileForms.valid;
    }
    

    if (isFormValid || this.dialogMode === 'edit') {
      if (this.isIdentitySelected) {
        this.dialogMode === 'add' ? this.uploadIdentityDocument() : this.editIdentityDocument();
      } else {
        this.dialogMode === 'add' ? this.uploadPersonalDocument() : this.editPersonalDocument();
      }
    } else {
      // Show validation errors only when Save is clicked
      this.documentForm.markAllAsTouched();
      this.documentForm.updateValueAndValidity();
      if (this.isIdentitySelected) {
        // Show specific error messages
        if (this.documentForm.get('documentId')?.invalid) {
          this.toastr.error('Please enter a valid Document ID.');
        }
        if (this.chkexp && this.documentForm.get('expirationDate')?.invalid) {
          this.toastr.error('Please select a valid expiration date.');
        }
      } else {
        this.toastr.error('Please complete all required fields.');
      }
    }
  }
}


private processFiles(filesArray: File[]): void {
  if (!filesArray || filesArray.length === 0) return;

  if (this.isIdentitySelected) {
    // ✅ Identity → allow only one file
    const firstFile = filesArray[0];
    this.selectedFiles = [firstFile];

    this.documentForm.patchValue({
      files: [firstFile],
      name: firstFile.name
    });

    // Reset & init upload progress
    this.uploadProgressList = [{ progress: 0, status: 'uploading' }];
    this.simulateFileUpload(0);
    this.startUpload();

  } else {
    // ✅ Other categories → multi-upload
    this.selectedFiles.push(...filesArray);
    this.documentForm.get('files')?.setValue(this.selectedFiles);

    // Initialize upload progress for new files only
    filesArray.forEach(() => {
      this.uploadProgressList.push({ progress: 0, status: 'uploading' });
    });

    // Rebuild FormArray
    this.fileForms.clear();
    this.selectedFiles.forEach((file, idx) => {
      const fileForm = this.createFileForm(file);
      fileForm.patchValue({
        files: [file],
        name: file.name,
        description: file.name
      });

      // Apply category-scoped validation
      const selectedCategories = this.documentForm.get('categories')?.value;
      const nameControl = fileForm.get('name');
      if (nameControl) {
        nameControl.setValidators([
          Validators.required,
          Validators.maxLength(30),
          duplicateNameValidator(
            this.allPersonalDocs || this.data.existingDocuments || [],
            selectedCategories,
            undefined,
            'category'
          )
        ]);
        nameControl.updateValueAndValidity();
      }

      // Ensure errors are visible without requiring user interaction
      fileForm.get('name')?.markAsTouched();
      fileForm.get('description')?.markAsTouched();
      fileForm.updateValueAndValidity();
      this.fileForms.push(fileForm);
    });

    // Start upload simulation for each new file
    const startIndex = this.uploadProgressList.length - filesArray.length;
    for (let i = 0; i < filesArray.length; i++) {
      this.simulateFileUpload(startIndex + i);
    }

    this.startUpload();
  }

  this.scrollFilesToEnd();
}

// UI only: keep the newest attached file visible inside the scrollable list
private scrollFilesToEnd(): void {
  setTimeout(() => {
    const el = this.fileList?.nativeElement;
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    }
  });
}

// ⬇️ keep simulateFileUpload from before
private simulateFileUpload(index: number): void {
  const interval = setInterval(() => {
    if (this.uploadProgressList[index].progress >= 100) {
      clearInterval(interval);
      this.uploadProgressList[index].status = 'completed';
    } else {
      this.uploadProgressList[index].progress += 10;
    }
  }, 300);
}


// Browse handler
onFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;

  const files = Array.from(input.files);

  // Let processFiles handle selectedFiles + progress init
  this.processFiles(files);

  input.value = ''; // reset input
}

// Drop handler
onFileDropped(event: DragEvent): void {
  event.preventDefault();
  event.stopPropagation();

  if (event.dataTransfer && event.dataTransfer.files.length > 0) {
    const files = Array.from(event.dataTransfer.files);
    this.processFiles(files);

    this.isDragOver = false;
    event.dataTransfer.clearData();
  }
}


onDragEnd(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = false;
}

onDragEnter(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = true;
}

onDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = true;   // highlight on drag
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = false;  // remove highlight
}

  private startUpload(): void {
    this.isUploading = true;
    this.uploadProgress = 0;

    // Simulate upload progress
    const interval = setInterval(() => {
      this.uploadProgress += 5;
      if (this.uploadProgress >= 100) {
        clearInterval(interval);
        this.isUploading = false;
      }
    }, 100);

    console.log(this.documentForm)
    console.log(this.isUploading)
  }

  addTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.tags.push(value);
    }
    event.chipInput!.clear();
  }

  /** Max characters shown in a tag chip; display only - the stored tag value is never changed. */
  readonly maxTagChars = 15;

  truncateTag(tag: any): string {
    const text = tag == null ? '' : String(tag);
    return text.length > this.maxTagChars ? text.slice(0, this.maxTagChars).trimEnd() + '...' : text;
  }

  /** Full tag shown in the tooltip, only when truncated (empty string disables it). */
  tagTooltip(tag: any): string {
    const text = tag == null ? '' : String(tag);
    return text.length > this.maxTagChars ? text : '';
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);
    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  addTagToForm(event: MatChipInputEvent, index: number): void {
    const value = (event.value || '').trim();
    if (value) {
      const form = this.fileFormArray.at(index) as FormGroup;
      const tags = form.get('tags')?.value || [];
      tags.push(value);
      form.get('tags')?.setValue(tags);
    }
    event.chipInput?.clear();
  }

  removeTagFromForm(index: number, tag: string): void {
    const form = this.fileFormArray.at(index) as FormGroup;
    const tags = form.get('tags')?.value || [];
    const tagIndex = tags.indexOf(tag);
    if (tagIndex >= 0) {
      tags.splice(tagIndex, 1);
      form.get('tags')?.setValue(tags);
    }
  }



  // moveToNextStep(): void {
  //   this.documentForm.markAllAsTouched();
  //   this.documentForm.updateValueAndValidity();
    
  //   // Mark file forms as touched for validation
  //   this.fileForms.controls.forEach((form: any) => {
  //     form.markAllAsTouched();
  //     form.updateValueAndValidity();
  //   });

  //   if (this.currentStep === 1 && this.dialogMode === 'add') {
  //     if (this.documentForm.get('categories')?.valid && this.selectedFiles.length > 0) {
  //       this.currentStep = 2;
  //       const fileName = this.selectedFiles[0]?.name;
  //       if (fileName) {
  //         this.documentForm.patchValue({ name: fileName, description: fileName });
  //       }
  //     }
  //     return;
  //   }

  //   if ((this.currentStep === 2 || this.dialogMode === 'edit')) {
  //     // Check validation based on document type
  //     let isFormValid = false;
      
  //     if (this.isIdentitySelected) {
  //       // For identity documents, check main form validity (without expiration date)
  //       // Only check categories, documentType, documentId, and files
  //       const categoriesValid = this.documentForm.get('categories')?.valid ?? false;
  //       const documentTypeValid = this.documentForm.get('documentType')?.valid ?? false;
  //       const documentIdValid = this.documentForm.get('documentId')?.valid ?? false;
  //       const filesValid = this.documentForm.get('files')?.valid ?? false;
        
  //       isFormValid = categoriesValid && documentTypeValid && documentIdValid && filesValid;
  //     } else {
  //       // For personal documents, check if all file forms are valid
  //       isFormValid =  this.fileForms.valid;
  //     }

  //     console.log('isFormValid',isFormValid)
  //     console.log('isIdentitySelected',this.isIdentitySelected)
  //     console.log('dialogMode',this.dialogMode)
  //     console.log('fileform',this.fileForms)
  //     console.log('documentForm',this.documentForm)

  //     if (isFormValid || this.dialogMode === 'edit') {
  //       if (this.isIdentitySelected) {
  //         this.dialogMode === 'add' ? this.uploadIdentityDocument() : this.editIdentityDocument();
  //       } else {
  //         this.dialogMode === 'add' ? this.uploadPersonalDocument() : this.editPersonalDocument();
  //       }
  //     } else {
  //       // Show validation errors
  //       if (this.isIdentitySelected) {
  //         this.documentForm.markAllAsTouched();
  //       } else {
  //         this.fileForms.controls.forEach((form: any) => {
  //           form.markAllAsTouched();
  //         });
  //       }
  //     }
  //   }
  // }

  private getFormattedExpirationDate(): string {
    return this.datePipe.transform(this.documentForm.value.expirationDate, 'dd-MM-yyyy') || '';
  }



  // uploadIdentityDocument() {
  //   if (this.documentForm.valid) {

  //     console.log(this.selectedFiles);
  //     const formData = new FormData();
  //     formData.append('docid', this.documentForm.value.documentId);
  //     formData.append('doctype', this.documentForm.value.documentType.toLowerCase());
  //     formData.append('expiration_date', this.getFormattedExpirationDate() || '');
  //     formData.append('user_tags', JSON.stringify(this.tags));
  //     formData.append('file', this.selectedFiles[0]); // Assuming single file upload for simplicity


  //     console.log('Form Data to be submitted:', formData);
  //     this.auth.add_crediential_docs(this.data.index_country, formData).subscribe({
  //       next: (response: any) => {
  //         if (response.error == false) {
  //           this.toastr.success(response.msg);
  //           this.dialogRef.close(this.documentForm.value);
  //         } else {
  //           this.toastr.error(response.msg);
  //         }

  //       }
  //     })
  //     // this.dialogRef.close(formData);
  //   } else {
  //     this.documentForm.markAllAsTouched();
  //   }

  // }

  uploadIdentityDocument() {
     this.isUploading = true;
    //  console.log('formValue', this.documentForm.value);
    if (this.documentForm.valid) {
      const formData = new FormData();
      formData.append('docid', this.documentForm.value.documentId);
      formData.append('doctype', this.documentForm.value.documentType.toLowerCase());
      // Remove expiration date for identity documents as per the image
      formData.append('expiration_date', this.getFormattedExpirationDate() || '');
      formData.append('user_tags', JSON.stringify(this.tags));
      formData.append('file', this.selectedFiles[0]);

      this.auth.add_crediential_docs(this.data.index_country, formData).subscribe({
        next: (response: any) => {
          this.isUploading = false; 
          if (!response.error) {
            this.toastr.success(response.msg || 'Document uploaded successfully');
            this.dialogRef.close(response.data);
          } else {
            this.isUploading = false; 
            this.showFieldErrors(response.errors, response.msg);
          }
        },
        error: (err: any) => {
          this.isUploading = false; 
          // Handle HTTP errors including 409 conflicts
          if (err.status === 409) {
            this.toastr.error('A document with this name already exists. Please choose a different name.', 'Duplicate Document');
            
            // Mark the name field as invalid with duplicate error
            const nameControl = this.documentForm.get('name');
            if (nameControl) {
              nameControl.setErrors({ duplicateName: true });
              nameControl.markAsTouched();
            }
          } else {
            this.showFieldErrors(err.error?.errors, err.error?.msg || err.message);
          }
        }
      });
    } else {
      this.isUploading = false; 
      this.documentForm.markAllAsTouched();
    }
  }
  showFieldErrors(errors?: any[], fallbackMessage?: string) {
    const fieldMap: { [key: string]: string } = {
      docid: 'Document ID',
      doctype: 'Document Type',
      expiration_date: this.isIdentitySelected ? 'Expiration Date (not applicable)' : 'Expiration Date',
      user_tags: 'Tags',
      file: 'File',
      name: 'Document Name',
      description: 'Description'
    };

    if (Array.isArray(errors)) {
      errors.forEach(err => {
        const fieldLabel = fieldMap[err.field] || err.field;
        const errorMessage = err.msg || 'Invalid value';
        
        // Skip expiration date errors for identity documents
        if (this.isIdentitySelected && err.field === 'expiration_date') {
          return;
        }
        
        // Special handling for duplicate name errors
        if (err.msg && err.msg.toLowerCase().includes('same name already exists')) {
          this.toastr.error('A document with this name already exists. Please choose a different name.', 'Duplicate Document');
          
          // Mark the name field as invalid with duplicate error
          const nameControl = this.documentForm.get('name');
          if (nameControl) {
            nameControl.setErrors({ duplicateName: true });
            nameControl.markAsTouched();
          }
          
          // Also mark file form names if they exist
          this.fileForms.controls.forEach((form: any) => {
            const ctrl = form.get('name');
            if (ctrl) {
              ctrl.setErrors({ duplicateName: true });
              ctrl.markAsTouched();
            }
          });
        } else {
          this.toastr.error(`${fieldLabel} - ${errorMessage}`);
        }
      });
    } else if (fallbackMessage) {
      // Check if the fallback message contains duplicate name info
      if (fallbackMessage.toLowerCase().includes('same name already exists') || 
          fallbackMessage.toLowerCase().includes('duplicate')) {
        this.toastr.error('A document with this name already exists. Please choose a different name.', 'Duplicate Document');
        
        // Mark name fields as invalid
        const nameControl = this.documentForm.get('name');
        if (nameControl) {
          nameControl.setErrors({ duplicateName: true });
          nameControl.markAsTouched();
        }
        
        this.fileForms.controls.forEach((form: any) => {
          const ctrl = form.get('name');
          if (ctrl) {
            ctrl.setErrors({ duplicateName: true });
            ctrl.markAsTouched();
          }
        });
      } else {
        this.toastr.error(fallbackMessage);
      }
    } else {
      this.toastr.error('Something went wrong');
    }
  }

  editIdentityDocument() {
    if (this.documentForm.valid) {
     
      console.log(this.documentForm.value);
      let doctype = this.data.document.doctype

     let formData = {
        docid: this.documentForm.value.documentId,
        doctype: doctype,
        expiration_date: this.getFormattedExpirationDate(),
        tags: this.documentForm.value.categories,
        user_tags: this.tags,
      }

      this.auth.update_credentails(this.data.index_country, doctype, formData).subscribe({
        next: (response: any) => {
          if (response.error === false) {
            this.toastr.success('Document updated successfully');
            this.dialogRef.close(this.documentForm.value);
          } else {
            this.toastr.error(response.msg || 'Something went wrong');
          }
        },
        error: (err: HttpErrorResponse) => {
          // Try to extract the message from the nested error object
          const errorMessage = err.error?.msg || err.message || 'Unknown error occurred.';
          this.toastr.error(errorMessage, 'Update Failed');
          console.error('Error occurred while updating:', err);
        }
      });


      // this.dialogRef.close(formData);
    } else {
      this.documentForm.markAllAsTouched();
    }

  }

  

//   uploadPersonalDocumentcc(): void {
//     if (!this.fileForms.length) return;

//     let allValid = true;

//   this.fileForms.controls.forEach(form => {
//     if (form.invalid) {
//       allValid = false;
//       form.markAllAsTouched();
//     }
//   });

//   if (!allValid) {
//     this.toastr.error('Please complete all fields in the forms.');
//     return;
//   }

//   // Upload each document one by one
//   this.fileForms.controls.forEach(form => {
//     const formValue = form.value;
//     const formData = new FormData();
//     formData.append('name', formValue.name);
//     formData.append('description', formValue.description);
//     formData.append('expiration_date', this.datePipe.transform(formValue.expirationDate, 'dd-MM-yyyy') || '');
//     formData.append('tags', JSON.stringify(this.documentForm.value.categories));
//     formData.append('user_tags', JSON.stringify(formValue.tags || []));
//     formData.append('file', formValue.files[0]);

//     this.auth.add_personal_doc(this.data.index_country, formData).subscribe({
//       next: (response: any) => {
//         if (response.error === false) {
//           this.toastr.success(response.msg);
//           this.deleteFile(this.fileForms.controls.indexOf(form));
//           this.succes_msg.push(response.msg)
//          // this.successRes.push(response.data);
//           let a =  this.succes_msg.push(response.msg)
//           console.log('a',a)
//         } else {
//           this.toastr.error(response.msg );
//           this.error_msg.push(response.msg)
//           return
//         }
//         this.counter++
         
//           if(this.counter>=this.selectedFiles.length){
//             if(this.error_msg.length>=1){
//               this.toastr.error(this.error_msg[0])
//               this.counter=0
//               this.error_msg =[]
//               this.succes_msg =[]

//             } else {
              
//               this.toastr.success(this.succes_msg[0])
//               this.dialogRef.close(this.documentForm.value);
//             }
//           }
//       }
//     });
//   });

//   // Close only once all uploads are done (or move this into a counter)
// }

// Updated openAddCategoryDialog method in add-document-dialog.component.ts
openAddCategoryDialog(): void {
  const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
    width: '500px',
    data: { existingCategories: this.data.categories }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result && result.categoryName) {
      const payload = {
        category: result.categoryName,
        symbol: result.icon,
        id: result.categoryId || undefined
      };

      this.auth.add_tags(this.data.index_country, payload).subscribe({
        next: (res: any) => {
          if (res.error === false) {
            // Use the actual ObjectId returned from the API
            const newCategoryId = res.data?.id || res.data?.category_id || result.categoryName.toLowerCase();
            
            const newCategory = {
              id: newCategoryId,
              title: result.categoryName,
              count: 0,
              icon: result.icon,
              isActive: false
            };

            // Add to local categories list
            this.data.categories.push(newCategory);

            // Clean up the current categories array and add the new category
            const categoriesControl = this.documentForm.get('categories');
            let currentCategories = categoriesControl?.value || [];
            
            // Filter out null/undefined values and ensure we have valid categories
            const cleanCategories = currentCategories.filter((cat: any) => 
              cat != null && typeof cat === 'string' && cat.trim() !== ''
            );
            
            // Add the new category ID
            const updatedCategories = [...cleanCategories, newCategoryId];
            
            // Update the form control
            categoriesControl?.setValue(updatedCategories);
            
            // Trigger category selection logic to update validators and UI
            this.onCategorySelect({ value: updatedCategories } as MatSelectChange);

            // Re-apply validators for the new category selection
            this.applyCategoryNameValidators();

            // Show success message
            this.toastr.success(res.msg || 'Category created successfully');

            // Mark form as touched to show validation states
           // this.documentForm.markAsTouched();
            this.documentForm.updateValueAndValidity();
          } else {
            this.toastr.error(res.msg || 'Failed to create category');
          }
        },
        error: (err) => {
          console.error('API Error:', err);
          this.toastr.error(err?.error?.msg || 'Something went wrong while creating category.');
        }
      });
    }
  });
}

// Updated uploadPersonalDocument
uploadPersonalDocument(): void {
  if (!this.fileForms.length) return;

  let allValid = true;
  let successCount = 0;
  let errorMessages: string[] = [];
  const totalUploads = this.fileForms.length;

  // Validate forms
  this.fileForms.controls.forEach(form => {
    if (form.invalid) {
      allValid = false;
      form.markAllAsTouched();
    }
  });

  if (!allValid) {
    this.toastr.error('Please complete all fields in the forms.');
    return;
  }

  // 🔄 Show spinner before upload starts
  this.isUploading = true;

  let completed = 0;
  let uploadedDocs: any[] = [];

  // Get clean categories
  const selectedCategories = this.documentForm.value.categories || [];
  const cleanCategories = selectedCategories.filter((cat: any) => 
    cat != null && 
    typeof cat === 'string' && 
    cat.trim() !== '' && 
    cat !== 'files' && 
    this.isValidObjectId(cat) 
  );

  if (cleanCategories.length === 0) {
    this.toastr.error('Please select at least one valid category.');
    this.isUploading = false; // Hide spinner
    return;
  }

  this.fileForms.controls.forEach((form, index) => {
    const formValue = form.value;
    const formData = new FormData();
    formData.append('name', formValue.name);
    formData.append('description', formValue.description);
    formData.append('expiration_date', this.datePipe.transform(formValue.expirationDate, 'dd-MM-yyyy') || '');
    formData.append('tags', JSON.stringify(cleanCategories));
    formData.append('user_tags', JSON.stringify(formValue.tags || []));
    formData.append('file', formValue.files[0]);

    this.auth.add_personal_doc(this.data.index_country, formData).subscribe({
      next: (response: any) => {
        if (response.error === false) {
          successCount++;
          uploadedDocs.push(response.data);
        } else {
          errorMessages.push(response.msg || 'Upload failed');
        }
        finalize();
      },
      error: (err: any) => {
        errorMessages.push(err.error?.msg || 'Upload failed. Please try again.');
        finalize();
      }
    });

    const finalize = () => {
      completed++;
      if (completed === totalUploads) {
        // 🔄 Hide spinner after all requests finish
        this.isUploading = false;

        if (errorMessages.length > 0) {
          this.toastr.error(errorMessages[0], 'Upload Error');
        }
        if (successCount > 0) {
          this.toastr.success(`${successCount} document(s) uploaded successfully.`);
          this.dialogRef.close(uploadedDocs);
        }
      }
    };
  });
}


// Helper method to validate ObjectId format
private isValidObjectId(id: string): boolean {
  // MongoDB ObjectId is a 24-character hexadecimal string
  return /^[0-9a-fA-F]{24}$/.test(id);
}

  editPersonalDocument(): void {
    if (this.documentForm.valid) {

      // Get categories using getRawValue() to include disabled controls
    const rawFormValue = this.documentForm.getRawValue();
    const selectedCategories = rawFormValue.categories || [];
    
    // Clean and filter categories to ensure valid ObjectIds only
    const cleanCategories = selectedCategories.filter((cat: any) => 
      cat != null && 
      typeof cat === 'string' && 
      cat.trim() !== '' && 
      cat !== 'files' && 
      this.isValidObjectId(cat) 
    );

    let formdata = {
      name: this.documentForm.value.name,
      description: this.documentForm.value.description, 
      expiration_date: this.getFormattedExpirationDate() || '',
      tags: cleanCategories, // Use cleaned categories instead of disabled form value
      user_tags: this.tags
    }
      console.log('Form Data to be submitted:', formdata);
      // this.auth.update_personal(this.data.document.id, formdata).subscribe({
      //   next: (response: any) => {
      //     if (response.error == false) {
      //       this.toastr.success('Document updated successfully');
      //       this.dialogRef.close(this.documentForm.value);
      //     } else {
      //       this.toastr.error('Failed to update document');
      //     }
      //   }
      // })
      this.auth.update_personal(this.data.document.id, formdata).subscribe({
        next: (response: any) => {
          this.toastr.success('Document updated successfully');
          this.dialogRef.close(this.documentForm.value);
        },
        error: (err) => {
          if (err.error && err.error.errors) {
            err.error.errors.forEach((e: any) => {
              const control = this.documentForm.get(e.field);
              if (control) {
                control.setErrors({ serverError: e.msg });
                control.markAsTouched();
              }
              this.toastr.error(`${e.field} field is required`);
            });
          } else {
            this.toastr.error('Something went wrong!');
          }
        }
      });

    }
  }
  


   removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.uploadProgressList.splice(index, 1);
    this.fileForms.removeAt(index);
    if (this.selectedFiles.length === 0) {
      //this.fileForms.get('files')?.setErrors({ required: true });
      this.currentStep = 1; // Reset to file upload step if no files are selected
      
      // Clear all form data when going back to step 1
      this.resetFormData();
    }

  }
  // Clear All: reuses removeFile so state handling stays identical
  clearAllFiles(): void {
    while (this.selectedFiles.length > 0) {
      this.removeFile(this.selectedFiles.length - 1);
    }
  }
  deleteFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.fileForms.removeAt(index);

  }
  // Method to reset form data when going back to step 1
private resetFormData(): void {
  // Clear tags
  this.tags = [];
  
  // Clear file forms array
  this.fileForms.clear();
  
  // Reset document form fields except categories (keep category selection)
  if (this.isIdentitySelected) {
    this.documentForm.patchValue({
      documentId: '',
      expirationDate: '',
      tags: []
    });
  } else {
    this.documentForm.patchValue({
      name: '',
      description: '',
      expirationDate: '',
      tags: []
    });
  }
  
  // Clear validation errors
  // this.documentForm.markAsUntouched();
  // this.documentForm.markAsPristine();
  
  // Reset form validity
  Object.keys(this.documentForm.controls).forEach(key => {
    const control = this.documentForm.get(key);
    if (control && key !== 'categories' && key !== 'documentType') {
      control.setErrors(null);
    }
  });
}

  onCancel(): void {
  if (this.selectedFiles.length > 0) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Confirmation',
        message: 'Changes you made will not be saved. Do you want to continue?',
        confirmText: 'Yes',
        cancelText: 'No'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.dialogRef.close();
      }
    });
  } else {
    this.dialogRef.close();
  }
}

onCancelDialog(): void {
  this.dialogRef.close();
}

check_doctype_exp(event: any) {
  const doctype = event.value;
  this.docId = (this.docTypes[event.value] || 'Document ID') as string;

  const control = this.documentForm.get('expirationDate');
  
  // Check if the document type requires expiration date
  if (doctype === 'driver_license' || doctype === 'passport') {
    //control?.setValidators([Validators.required, expirationDateValidator()]);
    this.chkexp = true;
  } else {
    control?.clearValidators();
    control?.setValue(''); // Clear the value when not required
    this.chkexp = false;
  }

  control?.updateValueAndValidity();

  // Force view update
  console.log('chkexp value:', this.chkexp);
  this.cdRef.detectChanges();
}

  getFileSize(file: File): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    let size = file.size;
    let i = 0;
    while (size >= 1024 && i < sizes.length - 1) {
      size /= 1024;
      i++;
    }
    return `${size.toFixed(2)} ${sizes[i]}`;
  }

  // In add-document-dialog.component.ts
get fileFormGroups(): FormGroup[] {
  return this.fileForms.controls as FormGroup[];
}

  hasDuplicateNameErrors(): boolean {
    // Check main form for duplicate name errors
    const mainFormHasError = this.documentForm.get('name')?.hasError('duplicateName');
    
    // Check file forms for duplicate name errors
    const fileFormsHaveError = this.fileForms.controls.some((form: any) => 
      form.get('name')?.hasError('duplicateName')
    );
    
    return mainFormHasError || fileFormsHaveError;
  }

  clearDuplicateNameError(controlName: string, formIndex?: number): void {
    if (formIndex !== undefined) {
      // Clear error from specific file form
      const form = this.fileForms.at(formIndex) as FormGroup;
      const control = form.get(controlName);
      if (control && control.hasError('duplicateName')) {
        // Clear only the duplicateName error, keep other validators
        const errors = control.errors;
        if (errors) {
          delete errors['duplicateName'];
          // If no other errors, set to null, otherwise keep remaining errors
          control.setErrors(Object.keys(errors).length > 0 ? errors : null);
        }
        control.updateValueAndValidity();
      }
    } else {
      // Clear error from main form
      const control = this.documentForm.get(controlName);
      if (control && control.hasError('duplicateName')) {
        // Clear only the duplicateName error, keep other validators
        const errors = control.errors;
        if (errors) {
          delete errors['duplicateName'];
          // If no other errors, set to null, otherwise keep remaining errors
          control.setErrors(Object.keys(errors).length > 0 ? errors : null);
        }
        control.updateValueAndValidity();
      }
    }
  }
   onDescriptionInput(): void {
    const control = this.documentForm.get('description');
    if (control && control.value) {
      control.setValue(control.value.replace(/^\s+/, ''), { emitEvent: false });
    }
  }

  onNameInput(formIndex?: number): void {
    if (formIndex!== undefined) {
      const control = this.fileFormGroups[formIndex].get('name');
      if (control && control.value) {
        control.setValue(control.value.replace(/^\s+/, ''), { emitEvent: false });
      }
    } else {
      const control = this.documentForm.get('name');
      if (control && control.value) {
        control.setValue(control.value.replace(/^\s+/, ''), { emitEvent: false });
      }
    }
    // Clear duplicate name error when user starts typing
    this.clearDuplicateNameError('name', formIndex);
    
    // Debug: Log current validation state
    this.logValidationState(formIndex);
  }

  private logValidationState(formIndex?: number): void {
    if (formIndex !== undefined) {
      // Log file form validation state
      const form = this.fileForms.at(formIndex) as FormGroup;
      console.log(`File Form ${formIndex} validation:`, {
        valid: form.valid,
        nameErrors: form.get('name')?.errors,
        descriptionErrors: form.get('description')?.errors,
        nameValue: form.get('name')?.value
      });
    } else {
      // Log main form validation state
      console.log('Main Form validation:', {
        valid: this.documentForm.valid,
        nameErrors: this.documentForm.get('name')?.errors,
        descriptionErrors: this.documentForm.get('description')?.errors,
        nameValue: this.documentForm.get('name')?.value
      });
    }
  }

  // Method to check if all forms are ready for upload
  isReadyForUpload(): boolean {
    if (this.isIdentitySelected) {
      // For identity documents, only check essential fields (without expiration date)
      const categoriesValid = this.documentForm.get('categories')?.valid ?? false;
      const documentTypeValid = this.documentForm.get('documentType')?.valid ?? false;
      const documentIdValid = this.documentForm.get('documentId')?.valid ?? false;
      const filesValid = this.documentForm.get('files')?.valid ?? false;
       let expirationValid = true;
    if (this.chkexp) {
      expirationValid = this.documentForm.get('expirationDate')?.valid ?? false;
    }
    
    return categoriesValid && documentTypeValid && documentIdValid && expirationValid && filesValid;
    } else {
      return this.fileForms.length > 0 && this.fileForms.valid;
    }
  }

  //prevent space at 1st position
  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;

    // If space is pressed at position 0, prevent it
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  // allow only single space between words
  // validateSpacesHome(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   input.value = input.value.replace(/\s{2,}/g, ' ');

  //   this.documentForm.get('documentId')?.setValue(input.value, { emitEvent: false });
  // }
  validateSpacesHome(event: Event, controlName?: string) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/\s{2,}/g, ' ');

  if (controlName) {
    this.documentForm.get(controlName)?.setValue(input.value, { emitEvent: false });
  }
}

}